import ProjectInvitation from '@projectMembers/models/projectInvitation';
import Text from '@ui/components/Text/Text';
import { Avatar, Group } from '@mantine/core';
import Icon from '@ui/components/Icon/Icon';

import ProjectMemberRoleSelector from '../ProjectMemberRoleSelector/ProjectMemberRoleSelector';
import styles from './ProjectInvitationListItem.module.scss';

type ProjectInvitationListItemProps = {
	invitation: ProjectInvitation;
	onDelete?: ( invitation: ProjectInvitation ) => void;
	showDelete?: boolean;
};

const ProjectInvitationListItem = ( {
	invitation,
	onDelete,
	showDelete = false
}: ProjectInvitationListItemProps ) => (
	<Group position="apart" className={styles.ProjectInvitationListItem} noWrap>
		<Group spacing={5} noWrap style={{ minWidth: 0 }}>
			<Avatar size={20} radius="xl" bg="var(--color-bg-surface-container)">
				<Icon icon="timer_outlined" size={14} color="var(--color-text-secondary)" />
			</Avatar>
			<Group spacing={2} noWrap style={{ minWidth: 0 }}>
				<Text
					variant="footnote"
					color="var(--color-text-secondary)"
					style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
				>
					{invitation.email}
				</Text>
				<Text variant="caption-regular" color="var(--color-text-secondary)" style={{ whiteSpace: 'nowrap' }}>
					(Pending)
				</Text>
			</Group>
		</Group>
		<Group spacing={2} noWrap>
			<ProjectMemberRoleSelector
				selectedRole={invitation.role}
				roleOptions={[]}
				readonly={!showDelete}
				showRoles={false}
				showDelete={showDelete}
				onDelete={() => onDelete?.( invitation )}
			/>
		</Group>
	</Group>
);

export default ProjectInvitationListItem;
